export enum NewsletterComponentType {
  Intro = 0,
  FilmProgramme = 1,
  Shows = 2,
  NewFilm = 3,
  Announcement = 4,
  Generic = 5,
}

export const newsletterComponentTypeTranslations: Record<NewsletterComponentType, string> = {
  [NewsletterComponentType.Intro]: 'newsletter.section_type.intro',
  [NewsletterComponentType.FilmProgramme]: 'newsletter.section_type.film_programme',
  [NewsletterComponentType.Shows]: 'newsletter.section_type.shows',
  [NewsletterComponentType.NewFilm]: 'newsletter.section_type.new_film',
  [NewsletterComponentType.Announcement]: 'newsletter.section_type.announcement',
  [NewsletterComponentType.Generic]: 'newsletter.section_type.generic',
};

export const newsletterComponentTypeOptions = [
  { text: newsletterComponentTypeTranslations[NewsletterComponentType.Intro], val: NewsletterComponentType.Intro },
  {
    text: newsletterComponentTypeTranslations[NewsletterComponentType.FilmProgramme],
    val: NewsletterComponentType.FilmProgramme,
  },
  { text: newsletterComponentTypeTranslations[NewsletterComponentType.Shows], val: NewsletterComponentType.Shows },
  { text: newsletterComponentTypeTranslations[NewsletterComponentType.NewFilm], val: NewsletterComponentType.NewFilm },
  {
    text: newsletterComponentTypeTranslations[NewsletterComponentType.Announcement],
    val: NewsletterComponentType.Announcement,
  },
  { text: newsletterComponentTypeTranslations[NewsletterComponentType.Generic], val: NewsletterComponentType.Generic },
];
